import _typeof from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import defaultSettings from '@/settings';

/**
 * @description 获取当前浏览器运行环境
 */
export function isAlipayOrWechat() {
  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    sessionStorage.setItem('app_env', 'wechat');
  } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    sessionStorage.setItem('app_env', 'alipay');
  }
}

/**
 *  获取当前手机系统是安卓还是ios
 */
export function getSystemAgent() {
  // 判断是否为ios端访问
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    sessionStorage.setItem('app_system', 'ios');
  }
  if (/(Android|Adr)/i.test(navigator.userAgent)) {
    sessionStorage.setItem('app_system', 'android');
  }
}

/** 设置页面title */
export function getPageTitle(pageTitle) {
  var title = defaultSettings.title;
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
}

/**
 * 防抖
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var _later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(_later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(_later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && _typeof(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && _typeof(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * 判断是否为JSON
 */
export function isJsonString(str) {
  try {
    if (_typeof(JSON.parse(str)) === 'object') {
      return true;
    }
  } catch (e) {
    return false;
  }
}